module.exports = __webpack_public_path__ + "img/plants.00f2b1cf.png";